<template>
  <v-container>
    <!-- Removed Toolbar, using v-row/v-col for layout -->
    <v-row>
      <v-col cols="12">
        <v-card outlined class="pa-3">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            class="mb-4"
            label="Search products"
            v-model="search"
            :append-icon="search !== null ? 'mdi-close' : ''"
            @click:append="search = null"
            hide-details
            dense
          ></v-text-field>

          <v-checkbox
            v-model="showFormulas"
            hide-details
            dense
            color="secondary"
            v-if="getSelectedTradingRole !== TradingRoles.SALES_REP"
          >
            <template v-slot:label>
              <span class="v-label theme--light">
                Show Formulas
              </span>
            </template>
          </v-checkbox>

          <v-checkbox
            v-model="showPositions"
            hide-details
            dense
            color="secondary"
            v-if="isAdmin()"
          >
            <template v-slot:label>
              <span class="v-label theme--light">
                 Show Positions
              </span>
            </template>
          </v-checkbox>

          <v-checkbox v-model="favorite" hide-details dense color="secondary">
            <template v-slot:label>
              <span class="v-label theme--light"> Favorite </span>
            </template>
          </v-checkbox>
          <v-checkbox v-model="recent" hide-details dense color="secondary">
            <template v-slot:label>
              <span class="v-label theme--light">
                Recent Items
              </span>
            </template>
          </v-checkbox>
          <v-checkbox v-model="ira" hide-details dense color="secondary">
            <template v-slot:label>
              <span class="v-label theme--light">
                IRA Eligible
              </span>
            </template>
          </v-checkbox>
          <v-checkbox
            v-model="activelySelling"
            hide-details
            dense
            color="secondary"
          >
            <template v-slot:label>
              <span class="v-label theme--light">
                Actively Selling
              </span>
            </template>
          </v-checkbox>
          <v-checkbox
            v-model="activelyBuying"
            hide-details
            dense
            color="secondary"
          >
            <template v-slot:label>
              <span class="v-label theme--light">
                Actively Buying
              </span>
            </template>
          </v-checkbox>
          <v-checkbox
            v-model="hideInactive"
            hide-details
            dense
            color="secondary"
          >
            <template v-slot:label>
              <span class="v-label theme--light">
                Hide Inactive Products
              </span>
            </template>
          </v-checkbox>
          
          <v-btn 
            color="accent" 
            dark 
            tile 
            small 
            class="mt-3 mr-2"
            @click="clearAllFilters()"
          >
            Clear All
          </v-btn>
          <v-btn 
            icon 
            tile 
            small 
            class="mt-3"
            @click="refreshProducts"
          >
             <v-icon>mdi-refresh</v-icon>
          </v-btn>

        </v-card>
      </v-col>
    </v-row>



    <category-tree class="mt-4"></category-tree>
  </v-container>
</template>

<script>
import CategoryTree from '@/components/catalog/CategoryTree'
import { mapGetters } from 'vuex'
import { TradingRoles } from '@/util/constants'
import guardsMixin from '@/mixins/guards'

export default {
  name: 'CatalogFilters',
  mixins: [guardsMixin],
  data() {
    return {
      panels: [0, 1],
      timerId: null,
      TradingRoles
    }
  },
  components: {
    CategoryTree,
  },
  watch: {
    '$route.params.categoryId'() {
      // On category navigation, clear any pending debounced set and reset search
      clearTimeout(this.timerId)
      this.$store.commit('updateQueryField', {
        path: `search`,
        value: null,
      })
    },
  },
  methods: {
    refreshProducts() {
      window._VMA.$emit('refresh-products');
    },
    clearAll() {
      this.$store.dispatch('resetQueries')
      this.$router.push({path: '/trade'})
    },
    clearAllFilters() {
      this.$store.dispatch('resetQueries');
      // Navigate back to the main trade page to clear the category
      if (this.$route.path !== '/trade') {
          this.$router.push({path: '/trade'});
      }
    },
  },
  computed: {
    ...mapGetters([
      'getSelectedTradingRole',
    ]),
    search: {
      get() {
        return this.$store.getters['getQueryField'](`search`)
      },
      set(value) {
        clearTimeout(this.timerId)
        this.timerId = setTimeout(() => {
          this.$store.commit('updateQueryField', {
             path: `page`,
             value: 1
          });
          this.$store.commit('updateQueryField', {
            path: `search`,
            value,
          })
        }, 500)
      },
    },
    showFormulas: {
      get() {
        return this.$store.getters['getQueryField'](`showFormulas`)
      },
      set(value) {
        this.$store.commit('updateQueryField', {
          path: `showFormulas`,
          value,
        })
      },
    },
    showPositions: {
      get() {
        return !!this.$store.getters['getQueryField'](`showPositions`);
      },
      set(value) {
        this.$store.commit('updateQueryField', {
          path: `showPositions`,
          value,
        })
      },
    },
    favorite: {
      get() {
        return this.$store.getters['getQueryField'](`favorite`)
      },
      set(value) {
        this.$store.commit('updateQueryField', {
          path: `favorite`,
          value,
        })
      },
    },
    recent: {
      get() {
        return this.$store.getters['getQueryField'](`recent`)
      },
      set(value) {
        this.$store.commit('updateQueryField', {
          path: `recent`,
          value,
        })
      },
    },
    activelyBuying: {
      get() {
        return this.$store.getters['getQueryField'](`activelyBuying`)
      },
      set(value) {
        this.$store.commit('updateQueryField', {
          path: `activelyBuying`,
          value,
        })
      },
    },
    activelySelling: {
      get() {
        return this.$store.getters['getQueryField'](`activelySelling`)
      },
      set(value) {
        this.$store.commit('updateQueryField', {
          path: `activelySelling`,
          value,
        })
      },
    },
    ira: {
      get() {
        return this.$store.getters['getQueryField'](`ira`)
      },
      set(value) {
        this.$store.commit('updateQueryField', {
          path: `ira`,
          value,
        })
      },
    },
    hideInactive: {
      get() {
        return this.$store.getters['getQueryField'](`hideInactive`)
      },
      set(value) {
        this.$store.commit('updateQueryField', {
          path: `hideInactive`,
          value,
        })
      },
    },
  },
}
</script>

<style lang="sass">
.v-input--selection-controls
  margin-top: 0 !important
</style>
